"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { ListItem } from "@mui/material";
import { Skeleton, Button, Link, Text } from "@nxt-costco-com/forge-components";
import { Analytics } from "../../../../Analytics/index.js";
import { CostcoBox } from "../../../../Util/CostcoBox.js";
import { getListItemSx, SkeltonContainerSx, ButtonSx, LinkSx, TextSx, iconStyles } from "./styles.js";
const getIcon = (Icon) => {
  return /* @__PURE__ */ jsx(Icon, { style: iconStyles });
};
const NavItem = ({
  id,
  icon,
  label,
  to,
  isLoading,
  onSignOut,
  isSignOutItem,
  classicMenuKey
}) => {
  let ClickableComponent;
  const setClassicMenuKey = (key) => {
    if (typeof window !== "undefined") {
      window.sessionStorage.setItem("selectedMenuItem", key);
    }
  };
  if (isLoading) {
    ClickableComponent = /* @__PURE__ */ jsxs(CostcoBox, { sx: SkeltonContainerSx, children: [
      /* @__PURE__ */ jsx(Skeleton, { height: 24, variant: "circular", width: 24 }),
      /* @__PURE__ */ jsx(Skeleton, { height: 16, variant: "textBody", width: 256 })
    ] });
  } else {
    if (isSignOutItem) {
      ClickableComponent = /* @__PURE__ */ jsxs(
        Button,
        {
          onClick: () => onSignOut == null ? void 0 : onSignOut(to),
          sx: ButtonSx,
          uniqueId: id,
          variant: "text-button",
          disableRipple: true,
          children: [
            getIcon(icon),
            label
          ]
        }
      );
    } else {
      ClickableComponent = /* @__PURE__ */ jsxs(
        Link,
        {
          href: to,
          sx: LinkSx,
          uniqueId: id,
          onClick: () => setClassicMenuKey(classicMenuKey),
          children: [
            getIcon(icon),
            /* @__PURE__ */ jsx(Text, { sx: TextSx, uniqueId: id, variant: "t6", children: label })
          ]
        }
      );
    }
  }
  return /* @__PURE__ */ jsx(
    Analytics,
    {
      analyticData: {
        component: {
          trackedData: [label]
        }
      },
      children: /* @__PURE__ */ jsx(ListItem, { sx: () => getListItemSx(id), children: ClickableComponent })
    }
  );
};
export {
  NavItem
};
